export default "__VITE_ASSET__mZ5U_mny__"